import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@wds/alert';

const DocuSignBanner = ({ variant, children, onClose }) => (
	<Alert
		color={variant}
		showIcon
		dismissible={!!onClose}
		onClose={onClose}
	>
		{children}
	</Alert>
);

DocuSignBanner.propTypes = {
	variant: PropTypes.oneOf(['error', 'warning', 'info']).isRequired,
	children: PropTypes.node.isRequired,
	onClose: PropTypes.func,
};

DocuSignBanner.defaultProps = {
	onClose: null,
};

export default DocuSignBanner;
